<template>
    <div v-if="robot_list && robot_list.length > 0">
        <van-cell center label="手动加入助理的商品不受此控制">
            <span slot="title" style="font-size: 17px">助理系统自动发品开关</span>
            <van-switch v-model="switch_checked" slot="right-icon" active-color="#07c160" @change="changeSwitch"/>
        </van-cell>
    </div>
</template>

<script>
    import {Toast} from 'vant';

    export default {
        name: "Wp_robot_public_on_off_model",
        data(){
            return{
                switch_checked: true,
                robot_list:[],
            }
        },
        created() {
            this.getRobotList();
        },
        methods:{

            /**
             * 获取机器人列表
             */
            getRobotList(){
                this.$common.global_robot_list = [];
                this.$getRobotList(list=>{
                    // this.$common.global_robot_list = list;
                    this.robot_list = list;
                    if(this.$common.global_robot_list[0].public_send_status === "open"){
                        this.switch_checked = true;
                    }else if(this.$common.global_robot_list[0].public_send_status === "close"){
                        this.switch_checked = false;
                    }
                });
                // if(!this.$common.global_robot_list){
                //     let params = {
                //         // channel_name: this.test_channel_name,
                //         channel_name: this.$store.state.username,
                //     };
                //
                //     this.$getRobotByChannelname(params, response=>{
                //         if(response && response.code == 200){
                //             this.$common.global_robot_list = response.data.list;
                //             this.robot_list = response.data.list;
                //             if(this.$common.global_robot_list[0].public_send_status === "open"){
                //                 this.switch_checked = true;
                //             }else if(this.$common.global_robot_list[0].public_send_status === "close"){
                //                 this.switch_checked = false;
                //             }
                //         }
                //     })
                // }else{
                //     this.robot_list = this.$common.global_robot_list;
                //     if(this.$common.global_robot_list[0].public_send_status === "open"){
                //         this.switch_checked = true;
                //     }else if(this.$common.global_robot_list[0].public_send_status === "close"){
                //         this.switch_checked = false;
                //     }
                // }
            },

            changeSwitch(status){
                if(status){
                    this.changeRobotOnOff("open")
                }else{
                    this.changeRobotOnOff("close")
                }
            },

            changeRobotOnOff(send_status){
                let robot_list = this.$common.global_robot_list;
                if(robot_list){
                    this.sendRobotStatus(robot_list, send_status)
                }
            },

            sendRobotStatus(robot_list, status){
                let params = {
                    robot_id: robot_list[0].vcRobotSerialNo,
                    room_id: robot_list[0].vcChatRoomSerialNo,
                    send_status: status
                };
                this.$sendRobotStatus(params, response=>{
                    this.$log(response)
                    if(response && response.code === 200){
                        this.$log(this.switch_checked)
                        if(this.switch_checked){
                            Toast.success({
                                message: "系统发品开启"
                            })
                        }else{
                            Toast.success({
                                message: "系统发品关闭"
                            })
                        }
                        // setTimeout(()=>{
                        //
                        // }, 500)
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>